
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512.002 512.002"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M481.996 255.231l-48.583-34.652-2.734 49.031 27.217 19.412c9.332 6.657 22.292 4.483 28.945-4.845 6.656-9.33 4.487-22.29-4.845-28.946zM378.401.072c-25.093-1.399-46.57 17.808-47.968 42.902-1.401 25.126 17.85 46.572 42.901 47.968 25.037 1.395 46.566-17.759 47.968-42.902 1.399-25.093-17.808-46.568-42.901-47.968z"}}),_c('path',{attrs:{"d":"M451.723 346.46c-5.082-8.186-34.631-55.805-38.808-62.536l7.977-143.086c.945-16.952-12.031-31.458-28.981-32.404l-54.734-3.052c-14.156-.789-26.601 8.135-30.873 20.97l38.984-10.765-96.97 53.356a20.868 20.868 0 00-3.024 2.028l-66.668 53.77c-8.678 6.999-10.214 19.539-3.671 28.431l-34.778 69.302-27.127-13.614c-10.102-5.069-22.401-.989-27.472 9.113L23.48 441.719c-5.069 10.103-.989 22.403 9.113 27.472l23.884 11.985c-5.245 10.452-1.024 23.177 9.428 28.422 10.452 5.245 23.177 1.024 28.422-9.428 3.798-7.569 2.612-16.316-2.289-22.565.799-1.366 26.479-52.607 109.783-218.622l68.108-54.556 95.336-52.457-64.413 52.718-4.551 81.624-22.701 77.151-58.5 113.518c-6.076 11.79-1.444 26.273 10.346 32.349 11.784 6.073 26.27 1.447 32.347-10.346l59.547-115.547a24.007 24.007 0 001.692-4.223l24.923-84.699 19.683 1.098 43.661 70.36v122.011c0 13.263 10.751 24.015 24.015 24.015 13.263 0 24.015-10.751 24.015-24.015V359.123a24.007 24.007 0 00-3.606-12.663z"}})])
          )
        }
      }
    